var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("vue-loading", {
        attrs: {
          active: _vm.loading,
          "is-full-page": true,
          loader: "dots",
          color: "#70A1F0"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      })
    : _c("div", { attrs: { id: "shelvery-summary" } }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "column" },
            [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-heading" }, [
                  _c(
                    "h4",
                    {
                      staticClass: "card-title",
                      staticStyle: { float: "left" }
                    },
                    [_vm._v("Shelvery Summary")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn-primary",
                      staticStyle: { float: "right", cursor: "pointer" },
                      on: { click: _vm.downloadCSV }
                    },
                    [_vm._v("Download CSV")]
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.summary != null
                ? [
                    _vm._l(_vm.summary.summary, function(data, service) {
                      return [
                        _c("div", { key: service, staticClass: "card" }, [
                          _c("div", { staticClass: "card-body" }, [
                            _c("h3", [_vm._v(_vm._s(service.toUpperCase()))]),
                            _vm._v(" "),
                            _c("ul", { staticClass: "list-group" }, [
                              _c(
                                "li",
                                {
                                  staticClass:
                                    "d-flex justify-content-between align-items-center"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(service) +
                                      " resources with shelvery enabled\n                      "
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "badge badge-success badge-pill"
                                    },
                                    [_vm._v(_vm._s(data.enabled))]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "li",
                                {
                                  staticClass:
                                    "d-flex justify-content-between align-items-center"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(service) +
                                      " resources with shelvery  disabled\n                      "
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "badge badge-primary badge-pill"
                                    },
                                    [_vm._v(_vm._s(data.disabled))]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "li",
                                {
                                  staticClass:
                                    "d-flex justify-content-between align-items-center"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(service) +
                                      " resources with shelvery not configured\n                      "
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "badge badge-pill",
                                      class: {
                                        "badge-danger": data.not_configured > 0,
                                        "badge-success":
                                          data.not_configured === 0
                                      }
                                    },
                                    [_vm._v(_vm._s(data.not_configured))]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "li",
                                {
                                  staticClass:
                                    "d-flex justify-content-between align-items-center"
                                },
                                [
                                  _vm._v(
                                    "\n                      completed " +
                                      _vm._s(service) +
                                      " backups\n                      "
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "badge badge-success badge-pill"
                                    },
                                    [_vm._v(_vm._s(data.completed_backups))]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "li",
                                {
                                  staticClass:
                                    "d-flex justify-content-between align-items-center"
                                },
                                [
                                  _vm._v(
                                    "\n                      missing " +
                                      _vm._s(service) +
                                      " backups\n                      "
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "badge badge-pill",
                                      class: {
                                        "badge-danger":
                                          data.missing_backups > 0,
                                        "badge-success":
                                          data.missing_backups === 0
                                      }
                                    },
                                    [_vm._v(_vm._s(data.missing_backups))]
                                  )
                                ]
                              )
                            ])
                          ])
                        ])
                      ]
                    })
                  ]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "column" },
            [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-heading" }, [
                  _c(
                    "h4",
                    {
                      staticClass:
                        "card-title d-flex justify-content-between align-items-center"
                    },
                    [
                      _vm._v("\n            Shelvery Issues\n            "),
                      _vm.summary != null
                        ? _c(
                            "span",
                            {
                              staticClass: "badge badge-pill",
                              class: {
                                "badge-danger": _vm.summary.issues.length > 0,
                                "badge-success": _vm.summary.issues.length === 0
                              }
                            },
                            [_vm._v(_vm._s(_vm.summary.issues.length))]
                          )
                        : _vm._e()
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.summary != null
                ? [
                    _vm._l(_vm.summary.issues.missing, function(miss, index) {
                      return [
                        _c(
                          "div",
                          { key: index, staticClass: "card issue-card" },
                          [
                            _c("div", { staticClass: "issue-heading" }, [
                              _c("span", [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(miss.backup_type.toUpperCase()) +
                                      " - " +
                                      _vm._s(miss.name) +
                                      " "
                                  )
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "card-body issue-body" }, [
                              _c("p", { staticClass: "mb-1" }, [
                                _c("strong", [_vm._v("reason:")]),
                                _vm._v(
                                  " Missing " +
                                    _vm._s(miss.group) +
                                    " backup for " +
                                    _vm._s(miss.date)
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "mb-1" }, [
                                _c("strong", [_vm._v("account:")]),
                                _vm._v(" " + _vm._s(miss.account) + " "),
                                _c("strong", [_vm._v("region:")]),
                                _vm._v(" " + _vm._s(miss.region))
                              ])
                            ])
                          ]
                        )
                      ]
                    })
                  ]
                : _vm._e()
            ],
            2
          )
        ])
      ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c50adba8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c50adba8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Shelvery.vue
// module id = null
// module chunks = 